import { baseApi } from "@shared/api/baseApi"; // Import shared baseApi

interface FirstSkinResponse {
  status: string;
  error: string;
  product: {
    id: string;
    name: string;
    iconUrl: string;
  };
}

interface OnboardingProgressResponse {
  currentStep: string;
  hasFaceitId: boolean;
  isClanMember: boolean;
  hasPlayedMatch: boolean;
  hasFirstSkin: boolean;
  message: string;
}

export const onboardingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFirstSkin: builder.query<FirstSkinResponse, void>({
      query: () => "onboarding/first-skin",
    }),
    getOnboardingProgress: builder.query<OnboardingProgressResponse, void>({
      query: () => "onboarding/progress",
    }),
    getChooseFreeSkin: builder.mutation<{ status: string, error: string }, string>({
      query: (skinName) => ({
        url: `onboarding/choose-free-skin?skinName=${encodeURIComponent(skinName)}`,
      }),
    }),
  }),
});

export const { useGetFirstSkinQuery, useGetOnboardingProgressQuery, useGetChooseFreeSkinMutation } = onboardingApi;
